export default {
  fill: Styles.color.primary,
  fillDisabled: Styles.color.grey.eight,
};
